import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, useColorModeValue, ListItem, Badge } from '@chakra-ui/react';
import { Logout } from 'routes';
import { useAuth } from 'auth/auth.context';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react';
import { NotificationsContext } from 'contexts/NotificationsContext';

export function SidebarLinks(props) {
  const location = useLocation();

  // Chakra color mode
  const activeColor = useColorModeValue('gray.700', 'white');
  const inactiveColor = useColorModeValue('secondaryGray.600', 'secondaryGray.600');
  const activeIcon = useColorModeValue('brand.600', 'white');
  const textColor = useColorModeValue('secondaryGray.500', 'white');
  const brandColor = useColorModeValue('brand.600', 'brand.400');

  const { setUser } = useAuth();
  const history = useHistory();
  const { routes } = props;
  const notificationsContext = useContext(NotificationsContext);
  const unreadCount = notificationsContext?.unreadCount || 0;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const handleLogout = async (e) => {
    localStorage.clear();
    setUser(null);
    return history.push('/auth/signin');
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <>
            <Text
              fontSize="md"
              color={activeColor}
              fontWeight="bold"
              mx="auto"
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              pt="18px"
              pb="12px"
              key={index}
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (route.hide != undefined && route.hide === true) {
        return null;
      } else if (
        route.layout === '/admin' ||
        route.layout === '/auth' ||
        (route.layout === '/rtl' && route.accessible && route.accessible())
      ) {
        return (
          <NavLink key={index} to={route.layout + route.path}>
            {route.icon ? (
              <Box>
                <HStack
                  spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
                  py="5px"
                  ps="10px"
                >
                  <Flex px={'10px'} w="100%" alignItems="center" justifyContent="center">
                    <Box
                      color={activeRoute(route.path.toLowerCase()) ? activeIcon : textColor}
                      me="18px"
                    >
                      {route.icon}
                    </Box>
                    <Flex me="auto" align="center" gap="8px">
                      <Text
                        color={activeRoute(route.path.toLowerCase()) ? activeColor : textColor}
                        fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}
                      >
                        {route.name}
                      </Text>
                      {route.path === '/notifications' && unreadCount > 0 && (
                        <Badge
                          colorScheme="red"
                          borderRadius="full"
                          minW="18px"
                          h="18px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          fontSize="10px"
                          px="4px"
                        >
                          {unreadCount > 9 ? '9+' : unreadCount}
                        </Badge>
                      )}
                    </Flex>
                  </Flex>
                  <Box
                    h="36px"
                    w="4px"
                    bg={activeRoute(route.path.toLowerCase()) ? brandColor : 'transparent'}
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={activeRoute(route.path.toLowerCase()) ? activeColor : inactiveColor}
                    fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };

  const createLogout = (routes) => {
    return routes.map((route, key) => {
      return (
        <NavLink to={route.layout + route.path} key={key} onClick={handleLogout}>
          {route.icon ? (
            <Flex align="center" justifyContent="space-between" w="100%" ps="17px" mb="0px">
              <HStack mb="6px" spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}>
                <Flex px={'5px'} w="100%" alignItems="center" justifyContent="center">
                  <Box
                    color={activeRoute(route.path.toLowerCase()) ? activeIcon : inactiveColor}
                    me="12px"
                    mt="6px"
                  >
                    {route.icon}
                  </Box>
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase()) ? activeColor : 'secondaryGray.600'
                    }
                    fontWeight="500"
                  >
                    {route.name}
                  </Text>
                </Flex>
              </HStack>
            </Flex>
          ) : (
            <ListItem ms={null}>
              <Flex ps="34px" alignItems="center" mb="8px">
                <Text
                  color={activeRoute(route.path.toLowerCase()) ? activeColor : inactiveColor}
                  fontWeight="500"
                  fontSize="sm"
                >
                  {route.name}
                </Text>
              </Flex>
            </ListItem>
          )}
        </NavLink>
      );
    });
  };

  //  BRAND
  return (
    <>
      {createLinks(routes)}
      {createLogout(Logout)}
    </>
  );
  // return createLinks(routes);
}

export default SidebarLinks;
